module.exports = __webpack_public_path__ + "img/grass-2.15e0946a.png";